import {NgModule} from '@angular/core';
import {SectionSeparatorComponent} from './section-separator.component';

@NgModule({
  imports: [],
  declarations: [
    SectionSeparatorComponent
  ],
  exports: [SectionSeparatorComponent],
  providers: []
})
export class SectionSeparatorModule {
}
